import { Pipe, PipeTransform } from '@angular/core';

import { LanguagesService } from '../services/languages.service';

@Pipe({
	name: 'translate',
	pure : false
})
export class TranslatePipe implements PipeTransform {

	constructor(private languagesService : LanguagesService){ }

	transform(value: string): string {
		return this.languagesService.getValue(value) || value;
	}

}
